import { useEffect, useState } from "react";
import { fetchMe } from "../../lib/api";
import type { UserMe } from "../../lib/types";

export function TokenUsageWidget() {
  const [me, setMe] = useState<UserMe | null>(null);

  useEffect(() => {
    fetchMe().then(setMe).catch(() => {});
  }, []);

  if (!me) return null;

  const pct = me.tokens_limit > 0
    ? Math.min(100, Math.round((me.tokens_used / me.tokens_limit) * 100))
    : 0;

  function fmt(n: number): string {
    if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
    if (n >= 1_000) return `${(n / 1_000).toFixed(0)}K`;
    return String(n);
  }

  return (
    <div className="px-2 py-2 space-y-1">
      <div className="flex justify-between text-small text-fg-muted">
        <span>Токены</span>
        <span>{fmt(me.tokens_used)} / {fmt(me.tokens_limit)}</span>
      </div>
      <div className="h-1 rounded-full bg-border overflow-hidden">
        <div
          className="h-full rounded-full bg-accent-500 transition-all"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
